import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import $ from "jquery";
import {FormattedMessage} from "react-intl";

import ActionTypes from "../../misc/actionTypes";
import Analytics from './../../analytics';
import {toggleUserPopup, changeMessageBoxState} from "../../actions/actionFunctions";

// import QuoteButton from "./quoteButton";
import ScheduleButton from "./scheduleButton";
import {ContentType} from "../visComponents/constants";
import {getShowOtherLayouts} from "../visComponents/navigation/navUtils";

export class DesignButton extends Component {

  static propTypes = {
    quoteEnabled: PropTypes.bool.isRequired,
    handleResetButtonClick: PropTypes.func.isRequired,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.visualizerTutorialStep === 2 && this.props.visualizerTutorialStep === 1) {
      this.toggleDesignList();
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      designListOpened: false,
    };
  }

  handleWrapperBlur = (e) => {
    if (!e.target.closest('.des-list__item .mobilebutton') && !e.target.closest('.des')) {
      this.toggleDesignList();
    }
  };

  toggleDesignList = () => {
    if(!this.state.designListOpened)
      Analytics.sendClickEvent('design-list-toggle-opened');
    else
      Analytics.sendClickEvent('design-list-toggle-closed');

    this.setState({
      designListOpened: !this.state.designListOpened
    }, () => {
      if (this.state.designListOpened) {
        document.addEventListener('click', this.handleWrapperBlur);
      } else {
        document.removeEventListener('click', this.handleWrapperBlur);
      }
    })
  };

  handleDesignButtonClick = (analyticsEvent, contentType) => {
    Analytics.sendClickEvent(analyticsEvent);
    $(document).trigger(ActionTypes.OPEN_MOBILE_NAVIGATION); // open navigation
    $(document).trigger(ActionTypes.CHANGE_MOBILE_MENU_CONTENT_TYPE, [contentType]); // set navigation type
    this.toggleDesignList(); // close design buttons //
  };

  handleDesignResetClick = () => {
    Analytics.sendClickEvent("design-buttons-reset-button");
    this.toggleDesignList(); // close design buttons
    this.props.handleResetButtonClick();
  };

  render() {

    const fabricatorSettings = this.props.fabricatorData.settings;
    const showOtherLayouts = getShowOtherLayouts(fabricatorSettings);

    return (
      <div className={"des" + (this.state.designListOpened ? " des--opened" : "")}>
        <button className={"mobilebutton mobilebutton--design"
        + (this.state.designListOpened ? " mobilebutton--design--active" : "")} onClick={this.toggleDesignList}>
          <span className="mobilebutton-text"><FormattedMessage id="mobileMenu.designButton"/></span>
        </button>
        <ul className="des-list">
          <li className="des-list__item">
            <button className="mobilebutton mobilebutton--design2"
                    onClick={() => this.handleDesignButtonClick("design-buttons-products-button",ContentType.Design)}>
              <span className="mobilebutton-text"><FormattedMessage id="mobileMenu.designMenuProducts"/></span>
            </button>
          </li>
          <li className="des-list__item">
            <button className="mobilebutton mobilebutton--room"
                    onClick={() => this.handleDesignButtonClick("design-buttons-room-button",ContentType.DisplayRoom)}>
              <span className="mobilebutton-text"><FormattedMessage id="mobileMenu.designMenuRooms"/></span>
            </button>
          </li>
          {showOtherLayouts ? (
            <li className="des-list__item">
              <button className="mobilebutton mobilebutton--layout"
                      onClick={() => this.handleDesignButtonClick("design-buttons-layout-button",ContentType.Layout)}>
                <span className="mobilebutton-text"><FormattedMessage id="mobileMenu.designMenuLayout"/></span>
              </button>
            </li>
          ) : null}
          <li className="des-list__item">
            <button className="mobilebutton mobilebutton--reset"
                    onClick={this.handleDesignResetClick}>
              <span className="mobilebutton-text"><FormattedMessage id="mobileMenu.designMenuReset"/></span>
            </button>
          </li>
          <ScheduleButton scheduleButtonOnClick={this.toggleDesignList} buttonLayoutId={"designButtonMenu"}/>
          {/*{this.props.quoteEnabled ? (*/}
            {/*<li className="des-list__item">*/}
              {/*<QuoteButton/>*/}
            {/*</li>*/}
          {/*) : null}*/}
        </ul>
      </div>
    )
  }

}
const mapStateToProps = (store) => ({
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  fabricatorData: store.fabricatorState,
  visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
  visualizersLoadedLength: store.serverState.visualizersLoaded.length,
});
export default connect(mapStateToProps, {
  toggleUserPopup,
  changeMessageBoxState
})(DesignButton);
